/* eslint-disable jsx-a11y/anchor-is-valid */
import { translate } from 'src/locales/i18next/config';
import Translations from '../../../../locales/i18next/translations/translation';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';


type Props = {
  ticket?: {
    ticketId: number;
    messageCount: number;
  }[]
};


const HeaderChatMenu = (props: Props) => {
  const t = translate(Translations);
  const translation = 'pages.dashboard';
  const history = useHistory();

  const ticketArray = props.ticket || [];
  return (
    <div
      className={clsx("menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px", {
        "d-none": !(ticketArray.length > 0),
      })}
      data-kt-menu="true"
    >
      {ticketArray.slice(0, 5).map((ticket, index) => (
        <div key={index} className="menu-item px-5 mb-2">
          <a onClick={()=>{
            history.push({
            pathname: '/support',
            state: { id: ticket.ticketId },
          })}} className="menu-link px-5">
            <div className="d-flex w-100">
              <div>
                <div className="position-relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-mail"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"></span>{' '}
                </div>
              </div>
              <div className="ms-3 fs-6">
                {t(`${translation}.notificationsSection.unRead`)} {ticket.messageCount} {t(`${translation}.notificationsSection.new`)} {t(`${translation}.notificationsSection.message`)}
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export { HeaderChatMenu };
